import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';


@Component({
  selector: 'esc-hbl-entry-validation',
  templateUrl: './hbl-entry-validation.component.html',
  styleUrls: ['./hbl-entry-validation.component.scss']
})
export class HblEntryValidationComponent implements OnInit {

  readonly ELEMENT_ID_VIEW = "hbl_entry_validation_dialog";

  constructor(
    public dialogRef: MatDialogRef<HblEntryValidationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public displayedColumns: string[] = [
    "masterBlNumber",
    "containerNumber"
  ];
  
  public listData = [];

  ngOnInit() {
    this.listData = this.data;
  }

  public selectRow(data: any) {
    this.dialogRef.close(data);
  }
}